import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { XCircle, ArrowLeft, ShoppingBag } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancel() {
  return (
    <Layout>
      <div className="max-w-lg mx-auto text-center py-16 space-y-6" data-testid="payment-cancel">
        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto">
          <XCircle className="w-8 h-8 text-red-500" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-stone-900">Payment Cancelled</h1>
          <p className="text-stone-500 mt-2">
            Your payment was not completed. No charges have been made.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <Link to="/cart">
            <Button variant="outline" className="gap-2" data-testid="back-to-cart-btn">
              <ArrowLeft className="w-4 h-4" /> Back to Cart
            </Button>
          </Link>
          <Link to="/services">
            <Button className="gap-2" data-testid="browse-services-btn">
              <ShoppingBag className="w-4 h-4" /> Browse Services
            </Button>
          </Link>
        </div>
      </div>
    </Layout>
  );
}
